export enum Icon {
    Calculator = 'calculator',
    Close = 'close',
    DefaultImage = 'default-image',
    Error1 = 'error-1',
    Error2 = 'error-2',
    Plus = 'plus-add',
    Question = 'question-mark',
    Replay = 'replay',
    Arrow = 'arrow',
    Pdf = 'pdf',
    CheckboxSelected = 'checkbox-selected',
    EmailUnread = 'email-unread',
    EmailRead = 'email-read',
    LocationPin = 'location-pin',
    Phone = 'phone',
    UserAvatar = 'user-avatar',
    WebsiteGlobe = 'website-globe',
    Calendar = 'calendar',
    Edit = 'edit',
    Trash = 'trash',
    InfoIconOutline = 'info-icon-outline',
    CalendarDateConfirmed = 'calendar-date-confirmed',
    DefaultAvatar = 'default-avatar',
    OneShotAmount = 'one-time-payment',
    MonthlyAmount = 'recurrent-payment',
    HourGlass = 'hour-glass',
    ApproxTilde = 'approx-tilde',
    Tick = 'tick',
    Timer = 'timer',
    Warning = 'warning',
    Copy = 'copy',
    VideoPlay = 'video-play-icon'
}
